import component from './applicant_detail.vue'
export default component
